// 14 Oct (the Tbilisi streams): the top players of a battle qualify for a later battle among the winners, "the Grand
// Final". The battle's config says how many and what for (QualifyConfig); the lobby and the podium say the rule, and the
// result page tells a qualifier. Nothing is promised beyond the email with the date.
// 16 Oct: qualifying also takes at least one point (@shared/qualify, the one rule for every view and export). The rule
// keeps its words; the condition is said only to a player inside the top N who scored nothing.
import type { QualifyConfig } from '@shared/types';
import { qualifies } from '@shared/qualify';
import { ordinal } from '@/lib/kudos';

export { qualifies };

export const QUALIFY = {
  rule: (q: QualifyConfig) => `Top ${q.top} qualify for ${q.label}.`,
  yes: (q: QualifyConfig) => `You've qualified for ${q.label}`,
  yesLine: (rank: number) => `You finished ${ordinal(rank)}. We'll email you the date.`,
  another: (q: QualifyConfig) => `Another chance to qualify for ${q.label}`,
  /** For a player inside the top N with no points: the rule with its condition. */
  needsPoint: (q: QualifyConfig) => `Top ${q.top} with at least one point qualify for ${q.label}.`,
};

/** A place inside the top N that the rule still leaves out, as no points were scored. */
export const topWithoutPoints = (q: QualifyConfig | undefined, rank: number | undefined, score: number | undefined): boolean =>
  Boolean(q && typeof rank === 'number' && rank >= 1 && rank <= q.top) && !qualifies(q, rank, score);
